<template>
<div class="page_smart_park page_hezuo pB100">
	<div class="form_wrap">
		<div class="item">
			<div class="title">姓名</div>
			<div class="name">
				<van-field v-model="name" placeholder="请输入参观者姓名" />
			</div>
		</div>
		<div class="item flex" @click="cardPicker = true">
			<div class="item_l">
				<div class="title">证件类型</div>
				<van-field v-model="card_name" placeholder="请选择" readonly />
			</div>
			<div class="item_r">选择</div>
		</div>
		<div class="item">
			<div class="title">证件号码</div>
			<div class="name">
				<van-field v-model="card_no" placeholder="请输入证件号码" />
			</div>
		</div>
	</div>
	<div class="bottom">
		<div class="action big" @click="bindAdd">{{ id ? '编辑' : '添加' }}</div>
	</div>
	<!-- 证件类型 -->
	<van-popup v-model="cardPicker" position="bottom">
        <van-picker show-toolbar :columns="cardList" value-key="name" @cancel="cardPicker = false" @confirm="confrimCard" />
    </van-popup>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
			type: null, // 票类型
			name: null,
			phone: null,
			card_no: null,
			card_type: null,
			card_name: null,
			cardPicker: false,
			cardList: null, // 证件类型
			id: this.$route.query.id ? this.$route.query.id : null // 参观者id
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '智慧园区',
                    hiddenBack: true
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						// 证件类型
						this.getCardList()
						// 参观者详情
						if(this.id){
							this.getDetail()
						}
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			// 证件类型
			this.getCardList()
			// 参观者详情
			if(this.id){
				this.getDetail()
			}
        }
        
    },
	mounted() {
	},
    methods: {
		// 参观者详情
		getDetail(){
			var that = this
			var params = {
				token: that.token,
				id: that.id
			}
			that.$api.smartpark.visitordetail(params).then(res=>{
				if(res.code == 200){
					var info = res.result
					that.name = info.name
					that.phone = info.phone
					that.card_no = info.card_no
					that.card_type = info.card_type
					for(var i in that.cardList){
						if(that.cardList[i].id == info.card_type){
							that.card_name = that.cardList[i].name
						}
					}
				}
			})
		},
		// 证件类型
		getCardList(){
			var that = this
			// 是写死的 1身份证 2学生证 3护照 4其他
			var arr = [
				{ 
					id: 1, 
					name: '身份证'
				},
				{ 
					id: 2,
					name: '学生证' 
				},
				{ 
					id: 3,
					name: '护照' 
				},
				{ 
					id: 4, 
					name: '其他'
				}
			]
			that.cardList = arr
		},
		// 选择证件类型
		confrimCard(val){
			var that = this
			// console.log(val)
			that.card_type = val.id
			that.card_name = val.name
			that.cardPicker = false
		},
		// 添加
		bindAdd(){
			var that = this
			var params = {
				token: that.token
			}
			// 姓名
			if(!that.name){
				that.$toast('请填写姓名')
				return
			}else{
				params.name = that.name
			}
			// 证件类型
			if(!that.card_type){
				that.$toast('请选择证件类型')
				return
			}else{
				params.card_type = that.card_type
			}
			// 证件号
			if(!that.card_no){
				that.$toast('请填写证件号')
				return
			}else{
				params.card_no = that.card_no
			}
			// // 手机号
			// if(!that.phone){
			// 	that.$toast('请填写手机号')
			// 	return
			// }else if( !(/^1[3456789]\d{9}$/.test(that.phone)) ){
			// 	that.$toast('请检查手机号是否正确')
			// 	return
			// }else{
			// 	params.phone = that.phone
			// }
			if(that.id != null){
				params.id = that.id
				that.$api.smartpark.visitoredit(params).then(res=>{
					if(res.code == 200){
						that.$toast(res.message)
						// 更新已添加参观者
						var list = JSON.parse(localStorage.getItem('visitorList'))
						if(list && list.length != 0){
							for(var i in list){
								if(list[i].id == that.id){
									// 手动更新,避免列表分页造成的不更新
									list[i].name = that.name
									list[i].card_type = that.card_type
									list[i].card_no = that.card_no
									list[i].phone = that.phone
									localStorage.setItem('visitorList',JSON.stringify(list))
									break
								}
							}
						}
						that.$router.back()
					}
				})
			}else{
				that.$api.smartpark.visitorcreate(params).then(res=>{
					if(res.code == 200){
						that.$toast(res.message)
						that.$router.back()
					}
				})
			}
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
